export default __webpack_public_path__ + "static/media/build.46e06070.svg";